export default __webpack_public_path__ + "static/media/alejandro-roasso.2825bc85.webp";